// extracted by mini-css-extract-plugin
export default {"container":"WarningPopoverContent_container__U8X5G","contentWrapper":"WarningPopoverContent_contentWrapper__wy7VL","buttonWrapper":"WarningPopoverContent_buttonWrapper__tmAte"};